import { Link } from 'react-router-dom';
import './unauthorized.css';
import { isAuthenticated } from '../../services/api';
import Icon from '../../components/Icon';

function Unauthorized() {
    const backPath = isAuthenticated() ? '/' : '/login';
    const backLabel = isAuthenticated() ? 'Voltar ao início' : 'Ir para login';

    return (
        <div className='unauthorized-page'>
            <div className='unauthorized-card container-white'>
                <h1 className='unauthorized-title'>
                    <Icon iconClass='icon-padlock' size={28} />
                    <span>Desbloqueie este módulo</span>
                </h1>
                
                <p>
                    Este conteúdo não está incluído no seu plano atual.
                    Você pode desbloqueá-lo individualmente ou fazer upgrade para o Bertoli HUB completo e acessar todos os módulos.
                </p>

                <Link to={backPath} className='unauthorized-link'>
                    {backLabel}
                </Link>
            </div>
        </div>
    );
}

export default Unauthorized;
